export const PRESS_WIDGET_ID = 'press'
